import { render, staticRenderFns } from "./ContactInput.vue?vue&type=template&id=4047b8d6"
import script from "./ContactInput.vue?vue&type=script&lang=js"
export * from "./ContactInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports